import { isLoggedInState } from "@/atoms/accountState";
import { useRouter } from "next/router";
import { createContext, ReactNode, useContext, useEffect } from "react";
import { useRecoilValue } from "recoil";

interface AuthContextType {
  isLoggedIn: boolean;
}

const AuthContext = createContext<AuthContextType>({
  isLoggedIn: false,
});

const AuthProvider = ({
  children,
  redirectToIfNotLoggedIn,
}: {
  children: ReactNode;
  redirectToIfNotLoggedIn: string;
}) => {
  const isLoggedIn = useRecoilValue(isLoggedInState);
  const router = useRouter();

  useEffect(() => {
    if (!isLoggedIn) {
      router.push(redirectToIfNotLoggedIn);
    }
  }, [isLoggedIn]);

  return <AuthContext.Provider value={{ isLoggedIn }}>{children}</AuthContext.Provider>;
};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};
